import React, { useContext, useEffect, useRef, useState } from "react";
import { Navbar, Nav} from "react-bootstrap";
import classNames from "classnames";
import AppContext from "context/Context";
import Logo from "modules/common/Logo";
import SearchBox from "./SearchBox";
import { navbarBreakPoint, topNavbarBreakpoint } from "config";
import autoCompleteInitialItem from "data/autocomplete/autocomplete";
import TopNavRightSideNavItem from "./TopNavRightSideNavItem";
import { useLocation } from "react-router-dom";
import { useToast } from "./store/toasterStore";
import Toaster from "../Toaster";
import SoftBadge from "modules/common/SoftBadge";
import { Link } from "react-router-dom";
import {currentUser, externalUsers, getCurrentUserRole} from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";
import AgentDetailModal from "./AgentDetailModal";
import { POP_ACCESS } from "modules/utilities/utility_2";

const NavbarTop = () => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig,
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const isChat = pathname.includes("chat");

  const [showDropShadow, setShowDropShadow] = useState(false);

  const handleBurgerMenu = () => {
    (navbarPosition === "top" || navbarPosition === "double-top") &&
      setConfig("navbarCollapsed", !navbarCollapsed);
    (navbarPosition === "vertical" || navbarPosition === "combo") &&
      setConfig("showBurgerMenu", !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", setDropShadow);
    return () => window.removeEventListener("scroll", setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  return (
    <Navbar
      className={classNames("navbar-glass fs--1 navbar-top sticky-kit", {
        "navbar-glass-shadow": showDropShadow && !isChat,
      })}
      expand={
        navbarPosition === "top" ||
        navbarPosition === "combo" ||
        navbarPosition === "double-top"
          ? topNavbarBreakpoint
          : true
      }
    >
      {navbarPosition === "double-top" ? (
        <div className="w-100">
          <div className="d-flex flex-between-center">
            <NavbarTopElements
              navbarCollapsed={navbarCollapsed}
              navbarPosition={navbarPosition}
              handleBurgerMenu={handleBurgerMenu}
              burgerMenuRef={burgerMenuRef}
            />
          </div>
        </div>
      ) : (
        <NavbarTopElements
          navbarCollapsed={navbarCollapsed}
          navbarPosition={navbarPosition}
          handleBurgerMenu={handleBurgerMenu}
          burgerMenuRef={burgerMenuRef}
        />
      )}
      {!POP_ACCESS.includes(currentUser) && <AgentDetailModal />}
    </Navbar>
  );
};

const externalUser=(!externalUsers.includes(getCurrentUserRole())||secureLocalStorage.getItem("level")=='3')?true:false;

const NavbarTopElements = ({ navbarPosition, handleBurgerMenu }) => {
  const burgerMenuRef = useRef();
  const { title, message, variant } = useToast();
  useEffect(() => {}, [title]);
  const currentURL = window.location.href;
  return (
    <>
      {!currentURL.includes("next-call") ? (
        <>
          <Navbar.Toggle
            ref={burgerMenuRef}
            className={classNames("toggle-icon-wrapper me-md-3 me-2", {
              "d-lg-none":
                navbarPosition === "top" || navbarPosition === "double-top",
              [`d-${navbarBreakPoint}-none`]:
                navbarPosition === "vertical" || navbarPosition === "combo",
            })}
            as="div"
          >
            <button
              className="navbar-toggler-hamburger-icon btn btn-link d-flex flex-center"
              onClick={handleBurgerMenu}
              id="burgerMenu"
            >
              <span className="navbar-toggle-icon">
                <span className="toggle-line" />
              </span>
            </button>
          </Navbar.Toggle>

            <Logo at="navbar-top" width={40} id="topLogo" />
        </>
      ) : (
        <Link to="/" className="text-decoration-none">
          <SoftBadge className="fs-3 m-2 mb-0">Back</SoftBadge>
        </Link>
      )}
      <Nav
        navbar
        className={`align-items-center d-none d-${topNavbarBreakpoint}-block w-50`}
        as="ul"
      >
        <Nav.Item as="li">
          <div className="d-flex align-items-center justify-content-between w-70">
            {currentURL.includes("next-call") ||
              ( externalUser && (
                <SearchBox autoCompleteItem={autoCompleteInitialItem} />
              ))}
            <Toaster title={title} message={message} variant={variant} />
          </div>
        </Nav.Item>
      </Nav>

      {!currentURL.includes("next-call") && <TopNavRightSideNavItem />}
    </>
  );
};

export default NavbarTop;
